import React from "react";
import AppStatCard from "../../../lib/components/AppStatCard";

/** Grid column wrapper around the shared dashboard-style AppStatCard. */
const StatsCard = ({ amount, className = "col-12 col-md-4", ...props }) => {
  return (
    <div className={`${className} mb-4`}>
      <AppStatCard value={amount} {...props} />
    </div>
  );
};

export default StatsCard;
